import { NavLink, Outlet, Route, Routes } from 'react-router-dom';
import SitesPage from './pages/SitesPage';
import CheckPage from './pages/CheckPage';
import CheckResultPage from './pages/CheckResultPage';
import HistoryPage from './pages/HistoryPage';
import LeadsPage from './pages/admin/LeadsPage';
import PublicLandingPage from './pages/PublicLandingPage';
import PublicResultPage from './pages/PublicResultPage';
import { useRobotsMeta } from './useRobotsMeta';

export default function App() {
  useRobotsMeta();
  return (
    <Routes>
      {/* 公開ルート（認証なし・管理用ヘッダ/フッタなし） */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<PublicLandingPage />} />
        <Route path="/result/:checkId" element={<PublicResultPage />} />
      </Route>

      {/* 管理ルート（Basic認証・管理用レイアウト） */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<SitesPage />} />
        <Route path="leads" element={<LeadsPage />} />
        <Route path="check" element={<CheckPage />} />
        <Route path="check/:checkId" element={<CheckResultPage />} />
        <Route path="urls/:urlId/history" element={<HistoryPage />} />
      </Route>
    </Routes>
  );
}

function AdminLayout() {
  return (
    <div className="app">
      <header className="app-header">
        <div className="app-header__inner">
          <div className="app-brand">
            <span className="app-brand__mark">SEO</span>
            <span className="app-brand__name">SEOチェッカー 管理</span>
          </div>
          <nav className="app-nav">
            <NavLink to="/admin" end>
              クライアント一覧
            </NavLink>
            <NavLink to="/admin/leads">リード一覧</NavLink>
            <NavLink to="/admin/check">チェック実行</NavLink>
          </nav>
        </div>
      </header>

      <main className="app-main">
        <Outlet />
      </main>

      <footer className="app-footer">
        評価基準: Google Search Central 公式ドキュメント準拠（社内ナレッジ版）。
        本ツールのスコアは自社基準のルーブリック採点であり、検索順位を保証するものではありません。
      </footer>
    </div>
  );
}

function PublicLayout() {
  return (
    <div className="app app--public">
      <main className="app-main app-main--public">
        <Outlet />
      </main>
    </div>
  );
}
